export const listingSchemaEnhancer = ({ formData, schema, intl }) => {
  schema.properties.querystring.default = {
    sort_on: 'effective',
    sort_order_boolean: 'descending',
  };
  return schema;
};
